/**
 * Collapse the backend visit lifecycle into the 3-bucket vocabulary the
 * field surveyor actually thinks in (UX recommendations #2). Admin/detail
 * screens can still show the raw `status`; list views should call this.
 *
 *   scheduled                  → 'action'   (Needs you)
 *   in_progress                → 'working'  (Working)
 *   in_review | released | archived → 'done'     (Done)
 */

import type { Visit } from './services/visits'

export type PresentationStatus = 'action' | 'working' | 'done'

export function presentationStatusFromVisit(status: Visit['status']): PresentationStatus {
  switch (status) {
    case 'scheduled':
      return 'action'
    case 'in_progress':
      return 'working'
    case 'in_review':
    case 'released':
    case 'archived':
      return 'done'
  }
}

export function presentationStatusLabel(status: PresentationStatus): string {
  switch (status) {
    case 'action':
      return 'Needs you'
    case 'working':
      return 'Working'
    case 'done':
      return 'Done'
  }
}

/** Tailwind class suffix for the fs-tag variant, so `fs-tag fs-tag-${cls}`. */
export function presentationStatusTagClass(status: PresentationStatus): string {
  return status
}
